import React from "react";
// import EditForm from "../EditForm/EditForm";
import * as moment from "moment";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
export default function DetailsCard(props) {
  const { applicationDetails, appUserId, status } = props;
  const decode = useCurrentUser();
  const user = null;
  function formatNumberWithCommas(number) {
    return number?.toLocaleString("en-IN");
  }

  return (
    <div
      style={{
        boxShadow: " 0px 4px 6px 0px #00000026",
        position: "relative",
        backgroundColor: "#F8F8F8",
        borderRadius: "10px",
        height: "160px",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
        marginTop: "20px",
      }}
    >
      <div>
        <p
          style={{
            color: "#D32028",
            fontWeight: "550",
            fontFamily: "Inter-Medium",
            marginLeft: "40px",
            marginTop: "20px",
          }}
        >
          {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
            ? "Product Type"
            : "Institute Name"}{" "}
        </p>
        <p
          style={{
            color: "black",
            fontFamily: "Inter-Medium",
            marginLeft: "40px",
          }}
        >
          {applicationDetails
            ? applicationDetails?.profile?.userDetails?.instituteName
            : null}
        </p>
      </div>
      <div>
        <p
          style={{
            color: "#D32028",
            fontWeight: "550",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
            marginTop: "20px",
          }}
        >
          {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
            ? "Loan Amount"
            : "Fees to be Paid"}
        </p>
        <p
          style={{
            color: "black",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
          }}
        >
          ₹
          {applicationDetails?.profile?.userDetails?.loanAmount !== null
            ? formatNumberWithCommas(
                applicationDetails?.profile?.userDetails?.loanAmount
              )
            : null}
        </p>
      </div>
      <div>
        <p
          style={{
            color: "#D32028",
            fontWeight: "550",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
            marginTop: "20px",
          }}
        >
          EMI Amount
        </p>
        <p
          style={{
            color: "black",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
          }}
        >
          {applicationDetails?.profile?.userDetails?.emiAmount !== null
            ? `₹${
                formatNumberWithCommas(
                  applicationDetails?.profile?.userDetails?.emiAmount
                )
                  ? formatNumberWithCommas(
                      applicationDetails?.profile?.userDetails?.emiAmount
                    )
                  : "Yet to be selected"
              }`
            : "Yet to be selected"}
        </p>
      </div>
      <div>
        <p
          style={{
            color: "#D32028",
            fontWeight: "550",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
            marginTop: "20px",
          }}
        >
          First EMI Date{" "}
        </p>
        <p
          style={{
            color: "black",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
          }}
        >
          {applicationDetails?.profile?.userDetails?.emiDate
            ? moment(applicationDetails?.profile?.userDetails?.emiDate).format(
                "DD MMM YYYY"
              )
            : "Yet to be selected"}
        </p>
      </div>
      <div>
        <p
          style={{
            color: "#D32028",
            fontWeight: "550",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
            marginTop: "20px",
          }}
        >
          Salary
        </p>
        <p
          style={{
            color: "black",
            fontFamily: "Inter-Medium",
            marginLeft: "30px",
          }}
        >
          ₹
          {applicationDetails?.profile?.userDetails?.salary !== null
            ? formatNumberWithCommas(
                applicationDetails?.profile?.userDetails?.salary
              )
            : null}
        </p>
      </div>
      <div>
        <p
          style={{
            color: "#D32028",
            fontWeight: "550",
            fontFamily: "Inter-Medium",
            marginRight: "100px",
            marginTop: "20px",
          }}
        >
          Status
        </p>
        <p style={{ color: "black", fontFamily: "Inter-Medium" }}> {status}</p>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          right: 25,
          cursor: "pointer",
        }}
      >
        {/* <EditForm user={appUserId} /> */}
      </div>
    </div>
  );
}
